import Vue from 'vue'

let Events = new Vue({})
export default Events